import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.get("/api/planconfig", { params });
};

const getDpPlanConfig = () => {
  return restApi.get("/api/planconfig/dp");
};

const getIpPlanConfig = () => {
  return restApi.get("/api/planconfig/ip");
}

const getAllAccessControl = () => {
  return restApi.get("/api/planconfig/access-control");
}

const getConfigCd = (params) => {
  return restApi.get("/api/planconfig/configcd", { params });
};

const getMeasureDisplayNames = (moduleCd) => {
  return restApi.get("/api/planconfig/configcd", { params: { moduleCd, configCd: "MEASURE_DISPLAY_NAMES", activeFlg: true } });
};

const getConfigCds = params => {
  return restApi.post("/api/planconfig/configcds", params);
};

const upsert = data => {
  return restApi.post("/api/planconfig", data);
};

const remove = ids => {
  return restApi.delete(`/api/planconfig/${ids}`);
};

const planConfigService = {
  getAll,
  getDpPlanConfig,
  getIpPlanConfig,
  getAllAccessControl,
  getConfigCd,
  getConfigCds,
  getMeasureDisplayNames,
  upsert,
  remove
};



export default planConfigService;